import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Button, Container, FormGroup, Input, Label, Row, Col } from 'reactstrap';
import moment from 'moment';
import * as spinnerActions from '../actions/Spinner';
import { fetchReport } from '../utils/Api';
import Breadcrumb from '../components/AdminBreadcrumb';
import YearMonthPicker from '../components/common/YearMonthPicker';

class Reports extends React.Component {

    constructor(props) {
        super(props);
        this.state = { userInputDate: moment().format('YYYY-MM') };
    }

    getMonthlyReport = () => {
        this.props.actions.spin();
        fetchReport('reports/GetMonthlyReport', this.state).then(() => this.props.actions.dontSpin());
    }

    render() {
        return (
            <Container>
                <div style={{ paddingBottom: '10px' }}>
                    <Breadcrumb history={this.props.history} />
                </div>
                <Row className='mb-1'>
                    <Col>
                        <h3>Monthly Project Activity</h3>
                    </Col>
                </Row>
                <Row>
                    <YearMonthPicker value={this.state.userInputDate} onChange={(e) => this.setState({ userInputDate: e })} />
                </Row>
                <Row className='pt-1'>
                    <Col>
                        <Button className={'float-right'} onClick={this.getMonthlyReport}>View Report</Button>
                    </Col>
                </Row>
            </Container>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        reports: state.Reports,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            ...spinnerActions
        }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Reports);